import { render, staticRenderFns } from "./Comunicados.vue?vue&type=template&id=05b63aa0&scoped=true"
import script from "./Comunicados.vue?vue&type=script&lang=js"
export * from "./Comunicados.vue?vue&type=script&lang=js"
import style0 from "./Comunicados.vue?vue&type=style&index=0&id=05b63aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b63aa0",
  null
  
)

export default component.exports